@if (form!=null) {
  <form [formGroup]="form">
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Nome</label>
        <input class="mb-2 form-control" type="text" formControlName="nome">
        @if (!this.form.get('nome').valid) {
          <div>
            @if (this.form.get('nome').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>CPF:</label>
        <input class="mb-2 form-control" type="text" formControlName="cpf">
        @if (!this.form.get('cpf').valid) {
          <div>
            @if (this.form.get('cpf').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Parentesco:</label>
        <select class="form-control" formControlName="codRepTipo">
          @for (item of tipos; track item) {
            <option [value]="item.COD_REP_TIPO">{{item.DCR_REP_TIPO}}</option>
          }
        </select>
        @if (!this.form.get('codRepTipo').valid) {
          <div>
            @if (this.form.get('codRepTipo').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Celular:</label>
        <input class="mb-2 form-control" type="text" placeholder="(41) 999999999" formControlName="celular" mask="(00) 000000000">
        @if (!this.form.get('celular').valid) {
          <div>
            @if (this.form.get('celular').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Email:</label>
        <input class="mb-2 form-control" type="email" formControlName="email">
        @if (!this.form.get('email').valid && (this.form.get('email').touched || this.form.get('email').dirty)) {
          <div>
            @if (form.get('email').hasError('required')) {
              <small class="text-danger">
                Campo Obrigatório
              </small>
            }
            @if (form.get('email').hasError('email')) {
              <small class="text-danger">
                Email Inválido
              </small>
            }
          </div>
        }
      </div>
    </div>
  </form>
}